var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArchitecture = function SvgArchitecture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#461B14",
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.25,
    d: "m24.78 16 1.47-1.51v-3.24h-2.941v2.593h-2.206V11.25h-2.206v2.593h-2.206V11.25H13.75v3.24L15.22 16v12.75h9.56zm0 0h-2.207M13.75 28.75h12.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.25,
    d: "M18.75 28.75V25a1.25 1.25 0 1 1 2.5 0v3.75m-2.5-7.5v-1.875a1.25 1.25 0 1 1 2.5 0v1.875z"
  })));
};
export default SvgArchitecture;